import * as React from "react";
import { Link } from "gatsby";

import SideNav from "../slices/SideNav";

const longDate = (isoDate) =>
  new Date(isoDate).toLocaleDateString("en-GB", {
    day: "numeric",
    month: "long",
    year: "numeric",
    timeZone: "UTC",
  });

// Side navigation plus the article column, shared by every explainer page.
export const ExplainerShell = ({ navItems, slug, location, children }) => (
  <>
    <div className="h-6 md:h-10 bg-teal-alpha-30 mb-6 md:mb-10"></div>
    <div className="container flex flex-col md:flex-row items-start min-h-[70vh] antialiased">
      <SideNav
        navItems={navItems}
        currentSlug={slug}
        currentItem={location.hash}
      />
      <article className="info-content md:w-7/12 pb-10">{children}</article>
    </div>
  </>
);

export const ReviewedDate = ({ date, label = "Last reviewed" }) =>
  date ? (
    <p className="reviewed-date text-sm text-charcoal mt-2">
      {label}: <time dateTime={date.slice(0, 10)}>{longDate(date)}</time>
    </p>
  ) : null;

export const Sources = ({ sources, heading = "Sources" }) =>
  sources && sources.length > 0 ? (
    <section className="pt-4 md:pt-10" id="sources">
      <h2 className="text-lg md:text-xl font-bold text-charcoal mb-4">
        {heading}
      </h2>
      <ul>
        {sources.map((source) => (
          <li key={source.url}>
            <a href={source.url} target="_blank" rel="noreferrer">
              {source.title}
            </a>
          </li>
        ))}
      </ul>
    </section>
  ) : null;

export const RelatedGuides = ({ slugs, navItems }) => {
  const related = (slugs || [])
    .map((slug) => navItems.find((item) => item.slug === slug))
    .filter(Boolean);

  return related.length > 0 ? (
    <section className="pt-4 md:pt-10" id="related-guides">
      <h2 className="text-lg md:text-xl font-bold text-charcoal mb-4">
        Related guides
      </h2>
      <ul>
        {related.map((item) => (
          <li key={item.slug}>
            <Link to={`/${item.slug}/`}>{item.title}</Link>
          </li>
        ))}
      </ul>
    </section>
  ) : null;
};

export const Disclaimer = () => (
  <p className="text-sm text-charcoal pt-4 md:pt-10">
    This page is general information, not legal advice. Schengen Simple is a
    planning tool: border officials decide who may enter and for how long. Check
    the official sources above before you travel.
  </p>
);
